@if (orderTemplates()?.length > 0) {
<div class="section quickorder-table">
  <table
    cdk-table
    [dataSource]="orderTemplates()"
    class="table table-bordered table-lg mobile-optimized"
    data-testing-id="order-template-list"
  >
    <!-- Order template name -->
    <ng-container cdkColumnDef="title">
      <th cdk-header-cell *cdkHeaderCellDef data-testing-id="th-order-template-title">
        {{ 'account.order_template.list.table.template' | translate }}
      </th>
      <td
        cdk-cell
        *cdkCellDef="let orderTemplate"
        [attr.data-label]="'account.order_template.list.table.template' | translate"
      >
        <a [routerLink]="'/account/order-templates/' + orderTemplate.id" data-testing-id="order-template-list-title">
          {{ orderTemplate.title }}
        </a>
      </td>
    </ng-container>
    <!-- Creation date -->
    <ng-container cdkColumnDef="creationDate">
      <th cdk-header-cell *cdkHeaderCellDef data-testing-id="th-order-template-creation-date">
        {{ 'account.order_template.list.table.created' | translate }}
      </th>
      <td
        cdk-cell
        *cdkCellDef="let orderTemplate"
        [attr.data-label]="'account.order_template.list.table.created' | translate"
      >
        {{ orderTemplate.creationDate | ishDate : 'shortDate' }}
      </td>
    </ng-container>
    <!-- Number of line items -->
    <ng-container cdkColumnDef="lineItems">
      <th colspan="2" cdk-header-cell *cdkHeaderCellDef data-testing-id="th-order-template-line-items">
        {{ 'account.order_template.list.table.item' | translate }}
      </th>
      <td
        cdk-cell
        *cdkCellDef="let orderTemplate"
        [attr.data-label]="'account.order_template.list.table.item' | translate"
      >
        {{ 'account.order_template.items' | translate : { '0': orderTemplate.itemsCount } }}
      </td>
    </ng-container>
    <!-- Actions -->
    <ng-container cdkColumnDef="actions">
      <th cdk-header-cell *cdkHeaderCellDef class="d-none" data-testing-id="th-order-template-actions"></th>
      <td cdk-cell *cdkCellDef="let orderTemplate" class="column-price">
        @if (orderTemplate.items?.length) {
        <a class="btn-tool d-inline-flex align-top">
          <ish-product-add-to-basket
            ishProductContext
            [parts]="getParts(orderTemplate)"
            displayType="icon"
            cssClass="text-primary p-0"
          />
        </a>
        }
        <a
          class="btn-tool"
          [title]="'account.order_template.edit.heading' | translate"
          [routerLink]="'/account/order-templates/' + orderTemplate.id"
          data-testing-id="order-template-details-edit"
          ><fa-icon icon="pencil-alt"
        /></a>
        @if (orderTemplate.editable) {
        <a
          class="btn-tool"
          title="{{ 'account.order_template.list.link.remove' | translate }}"
          (click)="openDeleteConfirmationDialog(orderTemplate, deleteDialog)"
          data-testing-id="delete-order-template"
          ><fa-icon [icon]="['fas', 'trash-alt']"
        /></a>
        }
      </td>
    </ng-container>
    <!-- Header and Row Declarations -->
    <tr cdk-header-row *cdkHeaderRowDef="columnsToDisplay()"></tr>
    <tr cdk-row *cdkRowDef="let row; columns: columnsToDisplay()" data-testing-id="order-template-list-item"></tr>
  </table>
  <a [routerLink]="'/account/order-templates'">{{ 'dias.quickorder.see_more_order_template.link' | translate }}</a>
</div>
} @else {
<p data-testing-id="emptyList">{{ 'account.order_template.list.no_templates.text' | translate }}</p>
}

<!-- the title will be set dynamically -->
<ish-modal-dialog
  #deleteDialog
  [options]="{
    confirmText: 'account.order_template.delete.button.text' | translate,
    rejectText: 'account.cancel.button.label' | translate,
    titleText: 'undefined'
  }"
  (confirmed)="delete($event)"
>
  {{ 'account.order_template.delete.do_you_really.text' | translate }}
</ish-modal-dialog>
